import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, Row, Col } from '@si-armes/dsfr-react';

const BoutonEtape = ({
    nameBtnSuivant,
    labelBtnSuivant,
    labelBtnPrecedent,
    actionPrecedente,
    btnSuivantDisabled,
    btnPrecedentVisible,
    btnSuivantVisible,
}) => {
    return (
        <Row gutters className="margin-top-lg">
            <Col lg={6}>
                {btnPrecedentVisible && (
                    <Button
                        type="button"
                        onClick={actionPrecedente}
                        name="retourEtape1"
                        variant="secondary"
                    >
                        {labelBtnPrecedent}
                    </Button>
                )}
            </Col>
            <Col lg={6} className="text-right">
                {btnSuivantVisible && (
                    <Button
                        name={nameBtnSuivant}
                        variant="primary"
                        type="submit"
                        disabled={btnSuivantDisabled}
                    >
                        {labelBtnSuivant}
                    </Button>
                )}
            </Col>
        </Row>
    );
};

BoutonEtape.propTypes = {
    nameBtnSuivant: PropTypes.string,
    labelBtnSuivant: PropTypes.string,
    labelBtnPrecedent: PropTypes.string,
    actionPrecedente: PropTypes.func,
    btnSuivantDisabled: PropTypes.bool,
    btnPrecedentVisible: PropTypes.bool,
    btnSuivantVisible: PropTypes.bool,
};

BoutonEtape.defaultProps = {
    btnSuivantDisabled: true,
    btnPrecedentVisible: true,
    btnSuivantVisible: true,
};

export default BoutonEtape;
